export default __webpack_public_path__ + "static/media/Rolling-1s-200px.e9e44da9.gif";